
const setCookiePolicy = (event) => {
  let date = new Date();
  date.setDate(date.getDate()+7);
  document.cookie = "useCookie=true; path=/; expires=" + date.toUTCString();
  const target = event.target.closest('.cookie-policy')
  if (!target) {
    return
  }
  target.style.display = "none"
}


const getCookie = (name) => {
  var re = new RegExp(name + "=([^;]+)");
  var value = re.exec(document.cookie);
  return (value != null) ? unescape(value[1]) : null;
}


export default (
  cookieButtonId
) => {
  const cookieButtonElement = document.getElementById(cookieButtonId)
  const existCookie = getCookie("useCookie")
  if( existCookie ) {
    const target = cookieButtonElement.closest('.cookie-policy')
    if (!target) {
      return
    }
    target.style.display = "none"
  }
  else {
    cookieButtonElement.addEventListener('click', setCookiePolicy)
  }
}
